import TreeView from './tree-view'
import TreeViewItem from './tree-view-item'

const install = (Vue) => {
  if (install.installed) return

  Vue.component('TreeView', TreeView)
  Vue.component('TreeViewItem', TreeViewItem)

  Array.prototype.rmIndex = function (index) {
    this.splice(index, 1)
    return this
  }
}

export default install

export const components = {
  TreeView,
  VERSION: '0.1.0'
}
